import workforceImg from '../../../assets/storymap/workforce.png';
import participantsIcon from '../../../assets/storymap/impacts/participants.svg';
import youthIcon from '../../../assets/storymap/impacts/youth.svg';
import trainingsIcon from '../../../assets/storymap/impacts/trainings.svg';
import partnersIcon from '../../../assets/storymap/impacts/partners.svg';
import { useId, useState } from 'react';

const WorkforceImpactCard = () => {
    const [isOpen, setIsOpen] = useState(false);
    const contentId = useId();

    return (
        <>
            <div className="bg-white">
                <div className="relative w-full h-[400px] overflow-hidden">
                    <img
                        src={workforceImg}
                        alt="people working in a shop"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute top-0 left-0 flex">
                        <p className="pl-20 bg-white/70 backdrop-blur-sm px-4 py-3 text-sm md:text-lg">
                            The Economic Opportunities for Communities Program (EOC)
                            supports community organizations offering career-awareness and career-prep programs in aviation,
                            construction trades, green jobs and maritime for underrepresented communities.
                        </p>
                    </div>
                </div>
            </div>
            <div className={`${isOpen ? 'pb-8' : 'pb-0'} bg-white py-2 pl-20 pr-8 shadow-xl scroll-mt-24`}>
                <div className='flex justify-between'>
                    <h1 className="text-3xl font-extrabold text-port-blue md:text-4xl lg:text-5xl">
                        SKCPF EOC Impact
                    </h1>
                    <div className="flex">
                        <button
                            type="button"
                            aria-expanded={isOpen}
                            aria-controls={contentId}
                            onClick={() => setIsOpen((v) => !v)}
                            className="focus:outline-none focus-visible:ring-2 focus-visible:ring-port-blue bg-white/70 backdrop-blur-sm"
                        >
                            <svg
                                className={`h-10 w-10 transition-transform hover:scale-110 ${isOpen ? 'rotate-180' : 'rotate-0'
                                    }`}
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            <span className="sr-only">{isOpen ? 'Collapse section' : 'Expand section'}</span>
                        </button>
                    </div>
                </div>
                <p className="mt-2 max-w-4xl text-sm md:text-lg pb-4">
                    Economic Opportunities for Communities has partnered with <strong>29 organizations</strong> and <strong>42 funded programs</strong>  from 2021 to current day. Collectively, our partners have affected the lives of many Port community members.
                </p>
                <div className="pr-8" id={contentId} hidden={!isOpen}>
                    {/* Impacts */}
                    <div className="mt-8 space-y-10">
                        {/* 3,615 Participants Served */}
                        <div className="relative flex items-center gap-6">
                            <img
                                src={participantsIcon}
                                alt=""
                                className="absolute left-3 top-1/2 w-28 -translate-y-1/2 opacity-90"
                            />
                            <div className="z-20 text-6xl font-black leading-none tracking-tight text-black md:text-7xl">
                                3,615
                            </div>
                            <div className="leading-tight">
                                <div className="text-lg font-extrabold text-black md:text-xl">Participants</div>
                                <div className="text-lg font-extrabold text-black md:text-xl">Served</div>
                            </div>
                        </div>

                        {/* 187 Youth Enrolled */}
                        <div className="flex items-center gap-4">
                            <img
                                src={youthIcon}
                                alt=""
                                className="w-16"
                            />
                            <div className='flex flex-col items-start'>
                                <div className="text-6xl font-black leading-none tracking-tight text-black md:text-7xl">
                                    187
                                </div>
                                <div className="text-lg font-extrabold leading-tight text-[#79B943] md:text-xl">
                                    Youth Enrolled
                                </div>
                            </div>
                        </div>

                        {/* 1,369 Trainings and Workshops */}
                        <div>
                            <div className="flex items-center gap-6">
                                <div className="text-6xl font-black leading-none tracking-tight text-black md:text-7xl">
                                    1,369
                                </div>
                                <img
                                    src={trainingsIcon}
                                    alt=""
                                    className="w-28"
                                />
                            </div>
                            <div className="pl-4 text-lg font-extrabold leading-tight text-black md:text-xl">Trainings and Workshops</div>
                        </div>

                        {/* 2,555 Jobs... Placements */}
                        <div className="flex items-center gap-4">
                            <div className="text-7xl font-black leading-none tracking-tight text-[#782059] md:text-8xl">
                                2,555
                            </div>
                            <div className="pt-2 text-sm font-semibold leading-relaxed text-black md:text-base">
                                Jobs,
                                <br />
                                Internships,
                                <br />
                                Apprenticeships,
                                <br />
                                and Pre-Apprenticeship
                                <br />
                                Placements
                            </div>
                        </div>

                        {/* 116 Employer Partners */}
                        <div>
                            <div className="flex items-end gap-4">
                                <div className="text-7xl font-black leading-none tracking-tight text-black md:text-8xl">
                                    116
                                </div>
                                <img
                                    src={partnersIcon}
                                    alt=""
                                    className="w-20"
                                />
                            </div>
                            <div className="pl-4 text-lg font-extrabold leading-tight text-black md:text-xl">
                                Employer Partners
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WorkforceImpactCard;